var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.expand ? 'expand':'' , 'itemWrap']},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"itemCon"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }